/**
 * Public pages hotlink whatever an author pastes into an image URL field, so anything
 * that is not plain https is dropped rather than rendered. Checked on render as well as
 * on write, since nothing has been checked up to now.
 */
export const publicImageUrl = (url: string | null | undefined) => {
    if (!url) {
        return undefined;
    }

    try {
        return new URL(url).protocol === "https:" ? url : undefined;
    } catch {
        return undefined;
    }
};
